import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['webhook']}`;

const WebhooksStatisticsPage = () => {
  const fetch = useFetch();

  const [webhook, setWebhook] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, webhookId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks/${webhookId}`)
      .then(({ webhook }) => setWebhook(webhook))
      .catch(setError);
  }, [accountId, domainId, webhookId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${webhook?.name || 'Unnamed text message'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/webhooks`}>{page}</Anchor>
        <Text>{webhook?.name || 'Unnamed text message'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={webhook?.name} scope="webhooks" id={webhookId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default WebhooksStatisticsPage;
